// import React from "react";

// const Engdesignabout = () => {
//   return (
//     <div style={styles.container}>
//       <div style={styles.imageSection}>
//         <img
//           src="/image/Design-Mechanical-Engineering.jpg"
//           alt="ERP Solutions"
//           style={styles.image}
//         />
//       </div>
//       <div style={styles.textSection}>
//         <h2 style={styles.title}>
//           Revolutionizing Mechanical Engineering Design
//         </h2>
//         <p style={styles.description}>
//           Our engineering design solutions cater to a wide range of industries,
//           ensuring the optimal design, functionality, and efficiency of
//           mechanical systems. Whether you’re designing for manufacturing,
//           automotive, aerospace, or consumer products, we provide end-to-end
//           support throughout the design lifecycle.
//         </p>
//         <p style={styles.description}>
//           From initial conceptual design to detailed engineering, our team
//           offers expertise in materials selection, stress analysis, thermal
//           simulations, and the creation of 3D models. We ensure that every
//           design meets industry standards while optimizing performance, cost,
//           and manufacturability
//         </p>
//         <p style={styles.description}>
//           By using advanced CAD software and simulation tools, we focus on
//           refining designs to improve functionality, reduce material waste, and
//           enhance production efficiency. Our solutions are tailored to meet your
//           specific needs, from prototyping and testing to final production and
//           implementation.
//         </p>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "40px 5%",
//     backgroundColor: "white",
//     boxSizing: "border-box",
//     flexWrap: "wrap",
//   },
//   textSection: {
//     width: "50%",
//     paddingLeft: "40px",
//     textAlign: "left",
//   },
//   title: {
//     fontSize: "32px",
//     fontWeight: "bold",
//     marginBottom: "20px",
//     color: "black",
//   },
//   description: {
//     fontSize: "16px",
//     lineHeight: "1.6",
//     marginBottom: "15px",
//     textAlign: "justify",
//     color: "black",
//   },
//   imageSection: {
//     width: "45%",
//     textAlign: "center",
//   },
//   image: {
//     width: "100%",
//     maxWidth: "700px",
//     height: "auto",
//     borderRadius: "8px",
//   },
//   "@media (max-width: 768px)": {
//     container: {
//       flexDirection: "column",
//       padding: "20px",
//     },
//     textSection: {
//       width: "100%",
//       paddingLeft: "0",
//       order: 2,
//     },
//     imageSection: {
//       width: "100%",
//       order: 1,
//       marginBottom: "30px",
//     },
//     title: {
//       fontSize: "28px",
//       textAlign: "center",
//     },
//     description: {
//       fontSize: "14px",
//       textAlign: "left",
//     },
//   },
//   "@media (max-width: 480px)": {
//     title: {
//       fontSize: "24px",
//     },
//     description: {
//       fontSize: "13px",
//     },
//   },
// };

// // Convert the styles object to inline styles and media queries
// const responsiveStyles = `
//   @media (max-width: 768px) {
//     .erp-container {
//       flex-direction: column;
//       padding: 20px;
//     }
//     .erp-text-section {
//       width: 100%;
//       padding-left: 0;
//       order: 2;
//     }
//     .erp-image-section {
//       width: 100%;
//       order: 1;
//       margin-bottom: 30px;
//     }
//     .erp-title {
//       font-size: 28px;
//       text-align: center;
//     }
//     .erp-description {
//       font-size: 14px;
//       text-align: left;
//     }
//   }
//   @media (max-width: 480px) {
//     .erp-title {
//       font-size: 24px;
//     }
//     .erp-description {
//       font-size: 13px;
//     }
//   }
// `;

// export default Engdesignabout;



import React from "react";

const Engdesignabout = () => {
  return (
    <>
      <style>
        {`
        .erp-container {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 40px 5%;
          background-color: white;
          flex-wrap: wrap;
          box-sizing: border-box;
        }

        .erp-text-section {
          width: 50%;
          padding-left: 40px;
          text-align: left;
        }

        .erp-title {
          font-size: 32px;
          font-weight: bold;
          margin-bottom: 20px;
          color: black;
        }

        .erp-description {
          font-size: 16px;
          line-height: 1.6;
          margin-bottom: 15px;
          text-align: justify;
          color: black;
        }

        .erp-image-section {
          width: 45%;
          text-align: center;
        }

        .erp-image {
          width: 100%;
          max-width: 700px;
          height: auto;
          border-radius: 8px;
        }

        /* Tablet */
        @media (max-width: 768px) {
          .erp-container {
            flex-direction: column;
            padding: 20px;
          }
          .erp-text-section {
            width: 100%;
            padding-left: 0;
            order: 2;
          }
          .erp-image-section {
            width: 100%;
            order: 1;
            margin-bottom: 30px;
          }
          .erp-title {
            font-size: 28px;
            text-align: center;
          }
          .erp-description {
            font-size: 14px;
            text-align: left;
          }
        }

        /* Mobile */
        @media (max-width: 480px) {
          .erp-title {
            font-size: 24px;
          }
          .erp-description {
            font-size: 13px;
          }
        }
        `}
      </style>

      <div className="erp-container">
        <div className="erp-image-section">
          <img
            src="/image/Design-Mechanical-Engineering.jpg"
            alt="ERP Solutions"
            className="erp-image"
          />
        </div>
        <div className="erp-text-section">
          <h2 className="erp-title">
            Revolutionizing Mechanical Engineering Design
          </h2>
          <p className="erp-description">
            Our engineering design solutions cater to a wide range of industries,
            ensuring the optimal design, functionality, and efficiency of
            mechanical systems. Whether you’re designing for manufacturing,
            automotive, aerospace, or consumer products, we provide end-to-end
            support throughout the design lifecycle.
          </p>
          <p className="erp-description">
            From initial conceptual design to detailed engineering, our team
            offers expertise in materials selection, stress analysis, thermal
            simulations, and the creation of 3D models. We ensure that every
            design meets industry standards while optimizing performance, cost,
            and manufacturability.
          </p>
          <p className="erp-description">
            By using advanced CAD software and simulation tools, we focus on
            refining designs to improve functionality, reduce material waste, and
            enhance production efficiency. Our solutions are tailored to meet your
            specific needs, from prototyping and testing to final production and
            implementation.
          </p>
        </div>
      </div>
    </>
  );
};

export default Engdesignabout;
